module.exports = __webpack_public_path__ + "static/media/plantG.130fba08.png";